import { env } from '@/env';
import ky from 'ky';

export const api = ky.create({
  prefixUrl: env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
          request.headers.set('Authorization', `Bearer ${accessToken}`);
        }
      },
    ],
    beforeError: [
      async (error) => {
        const { response } = error;
        try {
          const data = await response.clone().json();

          if (Array.isArray(data)) {
            // Shape: [{ error, field, error_description }]
            const messages = (data as Array<{ error_description?: string }>)
              .map((e) => e.error_description)
              .filter(Boolean)
              .join(' ');
            if (messages) error.message = messages;
          } else if (
            typeof data === 'object' &&
            data !== null &&
            'message' in data
          ) {
            // Shape: { message }
            const msg = (data as { message?: string }).message;
            if (msg) error.message = msg;
          }
        } catch {
          // Fallback to default message if JSON parsing fails
        }
        return error;
      },
    ],
  },
});

export const getStorageUrl = (url: string) => {
  return `${env.VITE_API_STORAGE_BASE_URL}${url}`;
};
